import React from 'react'
import { FragmentProps } from '../../../interfaces/Publication'
import OVA from './OVA'

// Only create wrapper if it actually does something different
const INF = ({fragment, openButtons, setOpenButtons, rawMode = false}: FragmentProps) => {
    // If INF needs special behavior, add it here
    // Otherwise, just use OVA directly
    
    return (
        <OVA 
            fragment={fragment} 
            openButtons={openButtons} 
            setOpenButtons={setOpenButtons} 
            rawMode={rawMode}
        />
    )
}

export default React.memo(INF)